import { HelmetProvider } from 'react-helmet-async';

import { RouterProvider } from '@tanstack/react-router';

import './App.css';
import styles from './App.module.css';

import { useInterval } from '@/App.hooks';

import { tryRefreshToken, useRefreshOnBuild } from './auth/Auth.hooks';
import { router } from './App.router';

function App() {
	const INTERVAL_TIME = 60 * 1000;
	useRefreshOnBuild();
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);

	const classNames = ['App', styles['app']];
	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
